import { ThemeUIStyleObject } from "theme-ui";

export const linkCTAStyle: ThemeUIStyleObject = {
  position: "absolute",
  left: "0",
  top: "0",
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const headingStylesGreen: ThemeUIStyleObject = {
  fontSize: ["h2", "h2", "h1"],
  mb: 0,
  color: "darkGreen",
  textAlign: "center",
  marginBottom: 9,
};

export const headingStylesCollection: ThemeUIStyleObject = {
  fontSize: ["h2", "h2", "h1"],
  mb: 0,
  color: "darkGreen",
  textAlign: "center",
  marginBottom: 15,
};
export const headingStylesWhiteCollection: ThemeUIStyleObject = {
  fontSize: ["h2", "h2", "h1"],
  mb: 10,
  color: "white",
  textAlign: "center",
};
export const textStylesWhiteCollection: ThemeUIStyleObject = {
  mb: 10,
  color: "white",
  textAlign: "center",
};
export const textStylesCollection: ThemeUIStyleObject = {
  mb: 10,
  color: "darkGreen",
  textAlign: "center",
};

export const headingStylesRed: ThemeUIStyleObject = {
  fontSize: ["h2", "h2", "h1"],
  mb: 0,
  color: "darkRed",
  textAlign: "center",
};

export const headingStylesRedLeft: ThemeUIStyleObject = {
  fontSize: ["h2", "h2", "h1"],
  mb: 0,
  color: "darkRed",
  textAlign: "left",
  marginBottom: 9,
};

export const flavourHeadingStyles: ThemeUIStyleObject = {
  fontSize: ["h3", "h2", "headingFlavour"],
  color: "darkGreen",
  textAlign: "left",
  marginBottom: ["21px", 9],
  height: ["65px", "auto"],
};

export const flavourTextStyles: ThemeUIStyleObject = {
  fontSize: ["h2", "h2", "h1"],
  textAlign: "left",
  marginBottom: 9,
};

export const mainContainerStyles: ThemeUIStyleObject = {
  position: "relative",
  zIndex: 1,
  bg: "white",
  py: [3, 6],
};
